<template>
    <div class="form1">
        <div class="top1">
            <van-notice-bar :scrollable="true">
                提示：请准确填写基本信息，该信息将影响套餐的生成。
            </van-notice-bar>
            <!-- <ul>
                                            <li class="ts"><span class="s1">提示</span><span class="s2">：请准确填写基本信息，该信息将影响套餐的生成。</span></li>
                                        </ul> -->
        </div>
        <div class="content1">
            <ul>
                <li>
                    <span>姓名</span>
                    <input type="text" v-model="data.NAME">
                </li>
                <li>
                    <span>性别</span>
                    <ul id="xbul" class="sexlab">
                        <li v-for="(item,index) in sexes" :key="index" :class="{'active':changeb==index}" @click="change(index)">{{item.value}}</li>
                    </ul>
                </li>
                <li>
                    <span>联系电话</span>
                    <input type="text" v-model="data.PHONE_NUM">
                </li>
                <li>
                    <span>证件类型</span>
                    <input type="text" name="" id="zj" :value="CARDTYPE" @click="openForm">
                </li>
                <li>
                    <span>证件号码</span>
                    <input type="text" v-model="data.ID_CARD">
                </li>
                <li>
                    <span>文化程度</span>
                    <ul class="lab">
                        <li v-for="(item,index) in educations" :key="index" :class="{'active':changebwh==index}" @click="changewh(index)">{{item.value}}</li>
                    </ul>
                </li>
                <li>
                    <span>职业</span>
                    <ul class="lab">
                        <li v-for="(item,index) in occupations" :key="index" :class="{'active':changebzy==index}" @click="changezy(index)">{{item.value}}</li>
                    </ul>
                </li>
                <li>
                    <span class="gxspan">关系</span>
                    <input type="text" name="" id="gx" :value="gxname" @click="openForm2" class="inputpadding">
                </li>
            </ul>
        </div>
        <div class="btn">
            <button type="button" @click="cancle">取消</button>
            <button type="button" class="btnsave" @click="save">保存</button>
        </div>
        <!-- <van-popup v-model="show" position="bottom">
                <div>
                    <div class="formTobLab">请选择证件类型</div>
                    <div class="zjlxlist">
                        <div v-for="(item,index) in cardTypes" @click="sel(item)" v-bind:key="index">
                            <span>{{item.value}}</span>
                        </div>
                    </div>
                </div>
            </van-popup> -->
        <van-actionsheet v-model="show" :actions="cardts" @select="onSelectCardt" />
        <van-actionsheet v-model="show2" :actions="rels" @select="onSelectRel" />
        <!-- <van-popup v-model="show2" position="bottom">
                        <div>
                            <div class="formTobLab">选择与此账号用户的关系</div>
                            <div class="zjlxlist">
                                <div v-for="(item,index)  in relations" v-bind:key="index" @click="sel2(item)">
                                    <span>{{item.value}}</span>
                                </div>
                            </div>
                        </div>
                    </van-popup> -->
    </div>
</template>
<script>
    import api from '@/fetch/api';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        Dialog,
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                data: {
                    NAME: '',
                    GENDER: '',
                    EDUCATION: '',
                    JOB: '',
                    RELATION: '',
                    ID_CARD: '',
                    PHONE_NUM: '',
                    CARD_TYPE: ''
                },
                CARDTYPE: '',
                show: false,
                show2: false,
                gxname: '',
                changeb: -1,
                changebwh: -1,
                changebzy: -1,
                rels: [],
                cardts: []
            }
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo", "occupations", "relations", "sexes", "cardTypes", "educations"]),
        },
        watch: {
            relations: function(val) {
                this.rels.push({
                    name: '选择与此账号用户的关系',
                    disabled: true
                });
                val.forEach(el => {
                    this.rels.push({
                        name: el.value,
                        value: el.key,
                        disabled: false
                    });
                });
            },
            cardTypes: function(val) {
                this.cardts.push({
                    name: '请选择证件类型',
                    disabled: true
                });
                val.forEach(el => {
                    this.cardts.push({
                        name: el.value,
                        value: el.key,
                        disabled: false
                    });
                });
            }
        },
        created() {
            this.setBasicData();
            // this.zylist= this.occupations;
            //    this.gxlx= this.relations;
            // this.xblist= this.sexes;
            //  this.zjlx= this.cardTypes;
            //  this.whlist= this.educations;
        },
        methods: {
            ...mapActions(["setBasicData"]),
            // sel(item) {
            //     this.data.CARD_TYPE = item.key;
            //     this.CARDTYPE = item.value;
            //     this.show = false;
            // },
            // sel2(item2) {
            //     console.log(item2);
            //     this.gxname = item2.value;
            //     this.data.RELATION = item2.key;
            //     this.show2 = false;
            // },
            onSelectRel(item) {
                this.gxname = item.name;
                this.data.RELATION = item.value;
                this.show2 = false;
            },
            onSelectCardt(item) {
                this.CARDTYPE = item.name;
                this.data.CARD_TYPE = item.value;
                this.show = false;
            },
            openForm() {
                this.show = true;
                document.activeElement.blur();
            },
            openForm2() {
                this.show2 = true;
                document.activeElement.blur();
            },
            change(index) {
                this.changeb = index;
                this.data.GENDER = this.sexes[index].key;
            },
            changewh(index) {
                this.changebwh = index;
                this.data.EDUCATION = this.educations[index].key;
            },
            changezy(index) {
                this.changebzy = index;
                this.data.JOB = this.occupations[index].key;
            },
            save() {
                api.addUser(this.userInfo.CUSTOMER_ID, this.data,this.userInfo.TOKEN).then(re => {
                    if (re.result == true) {
                        Toast.success('添加成功！');
                        this.$router.back(-1);
                    } else {
                        Toast.fail(re.msg);
                    }
                });
                // this.$emit('LOGIN', true);
                // this.$router.push({
                //     path: '/user/examPerson'
                // });
            },
            cancle() {
                // this.$emit('LOGIN', false);
                this.$router.back(-1);
            }
        },
    }
</script>

<style lang="less">
    .formTobLab {
        margin-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        font-size: 20px;
        line-height: 1.5rem;
        font-weight: bold;
        font-family: Arial, Helvetica, sans-serif;
        border-bottom: 1px solid #f0f0f0;
    }
    .zjlxlist {
        div {
            border-bottom: 1px solid #f0f0f0;
            line-height: 3rem;
            text-align: center;
        }
        i {
            color: #999;
        }
        .active {
            color: #99C51D;
        }
        span {
            font-size: 18px;
        }
    }
    .form1 {
        input[type="text"] {
            width: 90%;
            border-width: 1px;
            border-style: solid;
            border-color: rgba(228, 228, 228, 1);
            border-radius: 4px;
            height: 2em;
            padding-left: 10px;
        }
        .content1 {
            font-family: 'Arial Normal', 'Arial';
            font-weight: 400;
            font-style: normal;
            line-height: normal;
            font-size: 14px;
            .gxspan {
                top: 0.9em;
            }
            li {
                position: relative;
                padding: 0.3em 0em 0.3em 6em; // margin-bottom: 2px;
                min-height: 2em; // height: 2em;
            }
            span {
                display: block;
                width: 5em;
                position: absolute;
                left: 1em;
                top: 0.7em;
            }
            .sexlab {
                li {
                    margin-right: 0.5em;
                    display: block;
                    float: left;
                    text-align: center;
                    width: 20%;
                    height: 2.0em;
                    border-width: 1px;
                    border-style: solid;
                    border-color: #e4e4e4;
                    border-radius: 4px;
                    padding: 0px 0px 0px 0px;
                    line-height: 2em;
                }
                .active {
                    border: 1px solid red;
                }
            }
            .lab {
                li {
                    margin-right: 0.5rem;
                    margin-bottom: 5px;
                    display: block;
                    float: left;
                    text-align: center;
                    width: 45%;
                    height: 1.7em;
                    border-width: 1px;
                    border-style: solid;
                    border-color: #e4e4e4;
                    border-radius: 4px;
                    padding: 3px 0px 0px 0px;
                }
                overflow: hidden;
                .active {
                    border: 1px solid red;
                }
            }
        }
         .btn {
            text-align: center;
            padding: 2em 1em;
            button {
                font-size: 18px;
                padding: 0.5em 1em; // height: 38px;
                background-color: #FFF;
                border: 1px solid #aacd06;
                border-radius: 5px;
                color: #aacd06;
                text-align: center;
                width: 6em;
                margin: 0 0.5em;
            }
            .btnsave {
                font-size: 18px;
                background-color: #aacd06;
                border: 1px solid #aacd06;
                border-radius: 5px;
                color: #FFF;
                text-align: center;
            }
        }
        .top1 {
            font-family: 'Arial Normal', 'Arial';
            font-weight: 400;
            font-style: normal;
            line-height: normal;
            font-size: 14px;
            margin-bottom: 10px;
            .ts {
                background-color: rgba(233, 248, 248, 1);
                padding: 10px 5px 10px 5px;
                .s1 {
                    color: #ff9966;
                }
                .s2 {
                    color: #C9C9C9;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/personAdd.vue